import { render, staticRenderFns } from "./archiveContract.vue?vue&type=template&id=0bf21d42&scoped=true&"
import script from "./archiveContract.vue?vue&type=script&lang=js&"
export * from "./archiveContract.vue?vue&type=script&lang=js&"
import style0 from "./archiveContract.vue?vue&type=style&index=0&id=0bf21d42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf21d42",
  null
  
)

export default component.exports